import Cookies from "js-cookie";

export const isSessionExpired = (): boolean => {
  const session = Cookies.get("session");
  return !session;
};
